export default __webpack_public_path__ + "static/it1-c553ce3630c637724c37fdf685f363fc.jpg";